var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-page"},[_c('el-container',[_c('el-header',[_c('lHeader')],1),_c('el-container',[_c('el-aside',{attrs:{"width":"200px"}},[_c('lMenu')],1),_c('el-container',[_c('el-main',[_c('keep-alive',[_c('router-view',{key:_vm.key})],1)],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }